import { useState } from "react";
import "./index.scss";

export const SellSearchItem = ({
  focused,
  name,
  image_url,
  onClick,
  onHover
}) => {
  const [imageError, setImageError] = useState(null);

  const handleClick = () => onClick(name, true);

  return (
    <li name={name}>
      <button
        className={`sell-search-item ${focused && "focused"}`}
        type="button"
        onClick={handleClick}
        onMouseEnter={onHover}
      >
        {!imageError && (
          <img src={image_url} alt="brand" onError={setImageError} />
        )}
        <p>{name}</p>
      </button>
    </li>
  );
};
